import React from 'react';
import { PARIDHI_CONFIG } from '../../configs/paridhi.config';
import QuizGame from './QuizGame';

export default function ParidhiQuiz() {
  return <QuizGame config={PARIDHI_CONFIG} />;
}
